export const SHIPPING_METHOD_FIELD = 'shippingMethod';
export const INPUT_CONTEXT_SHIPPING_METHOD_FIELD = 'input-context-shippingMethod';
